import styled from 'styled-components'

export const Main = styled.main.attrs(() => ({}))`
  flex-grow: 1;

  display: flex;
  padding: 2rem;
`
